// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2WGwS","rootSuccess":"CompleteLink_rootSuccess__2m_oR","rootFailure":"CompleteLink_rootFailure__2jN1T","isDisabled":"CompleteLink_isDisabled__L4rmP"};